import React, { useContext } from "react";
import YouTubeVideos from "../youTubeVideos/YouTubeVideos";
import Applications from "./Applications";
import FmsReports from "./FmsReports";
import { Context } from "../LocalWrapper";

function FmsSoftware() {
  const context = useContext(Context);
  return (
    <div dir={context.dir}>
      <Applications />
      <FmsReports />
      <YouTubeVideos />
    </div>
  );
}

export default FmsSoftware;
